// import { ilcats } from '@monorepo/core/config'

import { MenuType, MenuCollectionType } from '@monorepo/deprecated/interfaces'

export const main: MenuType = [
  {
    name: 'Главная',
    url: '/',
    // exact: true,
  },
  // {
  //   name: 'О Патрон',
  //   url: '/pages/about-patron',
  // },
  {
    name: 'Блог',
    url: '/blog',
  },
  {
    name: 'Полезное',
    url: '/about-us',
    menu: [
      {
        name: 'Контакты',
        url: '/contacts',
      },
      {
        name: 'О нас',
        url: '/about-us',
      },

      // {
      //   name: '-Оптовым покупателям',
      // },
      // {
      //   name: '-Как оплатить',
      // },
      // {
      //   name: '-Доставка',
      // },
      // {
      //   name: '-Возврат товара',
      // },
      {
        name: 'Каталог товаров',
        url: '/goods',
      },
      {
        name: 'Статьи',
        url: '/blog',
      },
      {
        name: 'Обмен и возврат товара',
        url: '/pages/obmen_vozvrat_tovara',
      },
      {
        name: 'Доставка',
        url: '/pages/dostavka',
      },
      {
        name: 'Как оплатить заказ',
        url: '/pages/kak_oplatit_zazkaz',
      },
      {
        name: 'Договор оферты',
        url: '/pages/oferta',
      },
      {
        name: 'Пользовательское соглашение',
        url: '/pages/terms-of-use',
      },
      {
        name: 'Использование информации',
        url: '/pages/restrictions-of-use',
      },
      {
        name: 'Обработка персональных данных',
        url: '/pages/processing-personal-data',
      },
      {
        name: 'Политика конфиденциальности',
        url: '/pages/privacy-policy',
      },
    ],
  },
  // {
  //   name: 'Товары',
  //   url: '/goods',
  // },
  // {
  //   name: 'Кабинет',
  //   url: '/cabinet',
  //   menu: [
  //     {
  //       name: 'Перейти в кабинет',
  //       url: '/cabinet',
  //     },
  //     {
  //       name: 'Админпанель',
  //       url: '/admin',
  //       external: true,
  //       roles: ['admin'],
  //     },
  //     {
  //       name: 'Баланс',
  //       url: '/balance',
  //     },
  //     {
  //       name: 'Корзина',
  //       url: '/cart',
  //     },
  //     {
  //       name: 'Заказы',
  //       url: '/orders',
  //     },
  //     // {
  //     //   name: '-Скачать прайс-лист',
  //     // },
  //     {
  //       name: 'Гараж',
  //       url: '/garage',
  //     },
  //     // {
  //     //   name: 'Выход',
  //     //   url: '/logout',
  //     // },
  //   ],
  // },
  {
    name: 'О нас',
    url: '/about-us',
  },
  {
    name: 'Контакты',
    url: '/contacts',
  },
]

export const cabinet: MenuType = [
  {
    name: 'Перейти в кабинет',
    url: '/cabinet',
  },
  {
    name: 'Перейти в админпанель',
    url: '/admin',
    external: true,
    roles: ['admin'],
  },
  {
    name: 'Баланс',
    url: '/balance',
  },
  {
    name: 'Корзина',
    url: '/cart',
  },
  {
    name: 'Заказы',
    url: '/orders',
  },
  // {
  //   name: '-Скачать прайс-лист',
  // },
  {
    name: 'Гараж',
    url: '/garage',
  },
  // {
  //   name: 'Выход',
  //   url: '/logout',
  // },
]

const footerLinks: MenuType = [
  {
    name: 'Контакты',
    url: '/contacts',
  },
  {
    name: 'О нас',
    url: '/about-us',
  },
  {
    name: 'Статьи',
    url: '/blog',
  },
  {
    name: 'Обмен и возврат товара',
    url: '/pages/obmen_vozvrat_tovara',
  },
  {
    name: 'Доставка',
    url: '/pages/dostavka',
  },
  {
    name: 'Как оплатить заказ',
    url: '/pages/kak_oplatit_zazkaz',
  },
  {
    name: 'Договор оферты',
    url: '/pages/oferta',
  },
  {
    name: 'Пользовательское соглашение',
    url: '/pages/terms-of-use',
  },
  {
    name: 'Использование информации',
    url: '/pages/restrictions-of-use',
  },
  {
    name: 'Обработка персональных данных',
    url: '/pages/processing-personal-data',
  },
  {
    name: 'Политика конфиденциальности',
    url: '/pages/privacy-policy',
  },
]

export const initialState: MenuCollectionType = {
  main,
  footerLinks,
  cabinet,
  // userButton,
}
